import { Components } from '@mui/material';

export const MuiTypography: Components['MuiTypography'] = {
  styleOverrides: {
    root: {
      variants: [
        {
          /**
           * Custom small-caps implementation using uppercase transform
           * instead of fontVariant to avoid iOS scaling/rendering issues.
           */
          props: { variant: 'all-small-caps' },
          style: {
            textTransform: 'uppercase',
            fontSize: 8.5,
            fontWeight: 500,
            lineHeight: '16px',
            paddingTop: 2,
            marginBottom: -2,
          },
        },
      ],
    },
  },
};
